"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var url_1 = require("url");
var setTargetCookie = function (target) {
    if (target === void 0) { target = ''; }
    if (target !== '') {
        var cTarget = url_1.parse(target);
        var cPathName = cTarget ? url_1.parse(target).pathname : '';
        var cookies = new universal_cookie_1.default();
        cookies.set('savedLinkTarget', encodeURI(cPathName), { sameSite: 'none' });
    }
};
exports.default = setTargetCookie;
//# sourceMappingURL=setCookie.js.map